import { GET_IMAGINE_AI_API } from '../../config/constant/apiConstant';
import { paginatedImagineAIActions } from "../../redux/slicers/admin/paginatedImagineAI";
import { createDeleteApiAction, createGetListAction, createUpdateApiAction } from '../apiGenerator';

export const getImagineAIPageListApi = createGetListAction({
  endpoint: GET_IMAGINE_AI_API,
  actions: paginatedImagineAIActions,
  setGlobalSidebarFilters: true,
});

export const deleteImagineAIAPI = createDeleteApiAction({
  actions: paginatedImagineAIActions,
  endpointUrl: GET_IMAGINE_AI_API,
  optimistic: false,
  successMessage: 'The File is deleted successfully',
})

export const updateImagineAIAPI = createUpdateApiAction({
  actions: paginatedImagineAIActions,
  endpointUrl: GET_IMAGINE_AI_API,
})